//import * as selectors from './selectors';
import * as types from './types';
import * as actions from './actions';

import reducer from './reducer';

export { types, actions };
export default reducer;



// WEBPACK FOOTER //
// ./src/state/assessment/index.js